import React, { useState } from 'react';
import { Container, TextField, Button, Box, Typography, Paper, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import qwe from '../../assets/qwe.jpg'
const products = [
    {
        id: 1,
        title: 'MamaEarth Ubtan Natural for Dry Skin',
        author: 'Charles Dickens',
        price: 229,
        oldPrice: 299,
        cancelledDate: 'Sep 15, 2022'
    },
    {
        id: 2,
        title: 'MamaEarth Ubtan Ultra Light Gel',
        author: 'Charles Dickens',
        price: 314,
        oldPrice: 359,
        cancelledDate: 'Sep 15, 2022'
    }
];

function ProductListing() {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredProducts, setFilteredProducts] = useState(products);

    const handleSearch = () => {
        const results = products.filter(product =>
            product.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredProducts(results);
    };

    return (
        <Container>
            <div style={{ display: 'flex', alignItems: 'center', margin: '20px' }}>
                <TextField
                    label="Search your orders here"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSearch}
                    startIcon={<SearchIcon />}
                    style={{ marginLeft: '10px', height:'48px', borderRadius:'9px', width:'30%' }}
                >
                    Search Orders
                </Button>
            </div>
            <Grid container spacing={2}>
                {filteredProducts.map(product => (
                    <Grid item xs={12} key={product.id}>
                        <Paper>
                            <Box sx={{ display: 'flex', alignItems: 'center', padding: 2 }}>
                                <img src={qwe} alt='cart' height='100px' width='70px' style={{ marginRight: '20px' }} />
                                <Box sx={{ flexGrow: 1, display:'flex', flexDirection:'column' }}>
                                    <Typography component="span" variant="body1" color="textPrimary">
                                        {product.title}
                                    </Typography>
                                    <Typography component="span" variant="body2" color="text.secondary">
                                        {product.author}
                                    </Typography>
                                <Box className='price' sx={{ display: 'flex', alignItems: 'center', gap:'10px' }}>
                                    <Typography component="span" variant="body2" color="textPrimary">
                                        ₹{product.price}
                                    </Typography>
                                    <Typography component="span" variant="body2" color="text.secondary">
                                        <s>₹{product.oldPrice}</s>
                                    </Typography>
                                </Box>
                                </Box>
                                <Box className='cancel' sx={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                                    <Typography component="span" variant="body2" color="error">
                                        <CancelIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Cancelled on {product.cancelledDate}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <Typography align="center" color="textSecondary" style={{ marginTop: '20px' }}>
                No More Results To Display
            </Typography>
        </Container>
    );
}

export default ProductListing;
